<script setup lang="ts">
defineProps({
	text: {
		type: String,
		default: null,
	},
});
</script>
<template>
	<div class="divider">
		<span
			v-if="text"
			class="divider-text text-sm text-medium"
		>
			{{ text }}
		</span>
	</div>
</template>

<style lang="scss" scoped>
.divider {
	position: relative;
	text-align: center;
	width: 100%;

	.divider-text {
		padding: rem(8);
		background-color: colors-get(base, white);
		color: colors-get(gray, 600);
	}

	&::after {
		position: absolute;
		content: '';
		top: 50%;
		left: 0;
		width: 100%;
		height: 1px;
		background-color: colors-get(gray, 200);
		z-index: -1;
	}
}
</style>
